import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { VehiclebrandService } from "app/rest/vehiclebrand.service";
import { Rest } from "../../../../../../rest/rest_client";
import { AuthenticationService } from "../../../../../../core/services/authentication/authentication.service";
import { I18nService } from "../../../../../../services/i18n/i18n.service";
import { NotificationsService } from "../../../../../../services/notifications-service/notifications.service";
import { RestExt } from "../../../../../../services/rest-client-extension";
import { EntityListComponent } from "../../../../../../components/entity-list/entity-list.component";
import { BrandFormComponent } from "../brands-form/brand-form.component";
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";

import VehicleBrand = Rest.VehicleBrand;
import { VehicleService } from "app/rest/vehicle.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'app-brand-list',
    templateUrl: './brand-list.component.html',
    styleUrls: ['./brand-list.component.css'],
    providers: [VehiclebrandService, ConfirmationService, UserTimePipe, ExcelService, VehicleService],
    standalone: false
})
export class BrandListComponent
    extends EntityListComponent<VehicleBrand>
    implements OnInit {
    title: string = this.translateService.instant('tableManagement.brands.brands');

    @ViewChild(BrandFormComponent, { static: true })
    brandForm: BrandFormComponent;

    disableSave: boolean;

    user: Rest.User;
    EnabledFilter: SelectItem[];
    optionsdeleted: any[];
    canCreate: boolean;
    canDisable: boolean;

    constructor(
        private brandService: VehiclebrandService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        public translateService: TranslateService,
        public route: Router
    ) {
        super(
            brandService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
        this.brandService = brandService;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.brandForm;
        this.hasEntityFilters = false;
        /*Permissions */
        this.user = this.authenticationService.user;
        this.canCreate = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'INV_VEH_BRAND_CREATE'));
        this.canDisable = this.user.rolesProfiles.some(rp => rp.profile.actions.some(a => a.name === 'INV_VEH_BRAND_DISABLE'));
        /** */
        this.optionsdeleted = [
            { label: this.translateService.instant('general.disabled'), value: false },
            { label: this.translateService.instant('general.active'), value: true }
        ];
    }

    protected beforeLoad(): void {

        if(!this.route.url.includes("control-panel")){
            this.paginationRequest.filters["client"] = [this.user.client.id.toString()];
        }
        
        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }

    /*afterLoad() {
        this.brandService.getPage(this.paginationRequest, { clientId: this.authenticationService.user.client.id }).then((p) => {
            this.paginationResult = p;
        });

    }*/
    excelColumns = {};
    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.brands.brands');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
        const name = (entity: any) => entity.name ?? ''
        const disabled = (entity: any) => entity.disabled ?? ''
        this.excelColumns = {
            [this.translateService.instant('general.name')]: { bindField: name },
            [this.translateService.instant('general.disabled')]: { bindField: disabled },
        }
    }
}

